/**
 * SelectBusyDirective shows a spinner if the [selectBusy] condition of a select HTML element
*/
import { Directive, Input, ElementRef } from '@angular/core';


@Directive({
    selector: '[inputBusy]',
})
export class InputBusyDirective  {

    private _$select: JQuery;

    private readonly wrapperHtml: string = "<div class='loading'></div>";
    private readonly spinnerClass: string = "ng-directive-loading-spinner";

    @Input() set inputBusy(isBusy: boolean) {
        this._$select = $(this._element.nativeElement);
        this.refreshState(isBusy);
    }

    @Input() inputBusyIcon: string;

    constructor(private _element: ElementRef) { }



    refreshState(isBusy: boolean) {
        if (!this._$select) {
            return;
        }

        const icon = this.inputBusyIcon == null ? 'fa-spinner' : this.inputBusyIcon;
        const $iconHtml = $(`<i class='fa fa-spin ${icon} ${ this.spinnerClass }'></i>`);

        if (isBusy) {
            this._$select.attr('disabled', 'disabled');
            this._$select.wrap(this.wrapperHtml);
            const $parent = this._$select.parent('.loading');
            $parent.css({ position: 'relative' });
            $parent.prepend($iconHtml);
            $(`.${this.spinnerClass}`).css(this.loadingIconStyles);
        } else {
            $(`.${this.spinnerClass}`).remove();
            this._$select.unwrap();
            this._$select.removeAttr('disabled');
        }
    }

    private readonly loadingIconStyles = {
        'position': 'absolute',
        'left': '50%',
        'top': '10px',
        'z-index': '10000',
        'transform': 'translate(-50%, 50%)',
        '-ms-transform': 'translate(-50%, 50%)',
        '-webkit-transform': 'translate(-50%, 50%)',
    }
}
